import { v } from 'h3-valibot';
import { parseURL } from '~/utils/validation/parseURL';

/** Contentful `technicalComponent.fields.type` for onboarding settings. */
export const ONBOARDING_SETTINGS_TYPE = 'onboardingSettings';

/** Form-step keys in `configuration.steps` (intro/success are not configurable). */
export const ONBOARDING_SETTINGS_STEP_KEYS = [
  'industry',
  'applications',
  'role',
  'buyingPhase',
  'position'
] as const;

export type OnboardingSettingsStepKey =
  (typeof ONBOARDING_SETTINGS_STEP_KEYS)[number];

const onboardingStepFlagsSchema = v.object({
  visible: v.optional(v.boolean()),
  required: v.optional(v.boolean())
});

const onboardingStepsConfigurationSchema = v.object({
  industry: v.optional(onboardingStepFlagsSchema),
  applications: v.optional(onboardingStepFlagsSchema),
  role: v.optional(onboardingStepFlagsSchema),
  buyingPhase: v.optional(onboardingStepFlagsSchema),
  position: v.optional(onboardingStepFlagsSchema)
});

/**
 * Contentful `technicalComponent` configuration for `type: onboardingSettings`.
 *
 * Linked via Global Page Settings `additionalConfiguration`. Extend this object
 * when more onboarding settings are needed — do not hardcode URLs.
 */
export const onboardingSettingsConfigurationSchema = v.object({
  url: parseURL,
  steps: v.optional(onboardingStepsConfigurationSchema),
  suppressRouteSlugs: v.optional(v.array(v.string()))
});

export type OnboardingStepFlagsInput = {
  visible?: boolean;
  required?: boolean;
};

export type OnboardingStepsConfigurationInput = Partial<
  Record<OnboardingSettingsStepKey, OnboardingStepFlagsInput>
>;

export type ParsedOnboardingSettingsConfiguration = {
  url: string;
  steps?: OnboardingStepsConfigurationInput;
  suppressRouteSlugs?: string[];
};
